export enum ButtonSize {
  SMALL,
  DEFAULT,
  BIG,
}
